import { css, styled } from "styled-components";
import { StyledText } from "styles/Text";
import { colors } from "constants/colors";
import { ButtonType, MarginStyleType } from "types/Common";

export interface Props {
  text: string;
  type?: ButtonType;
  width?: string | number;
  height?: string | number;
  bgColor?: string;
  isDisabled?: boolean;
  leftComponent?: React.ReactNode;
  onClick?: () => void;
}

const RoundRectangleButton = ({
  text,
  type = "Normal",
  width,
  height,
  bgColor,
  isDisabled,
  leftComponent,
  onClick,
  $marginTop,
  $marginBottom,
  $marginLeft,
  $marginRight,
}: Props & MarginStyleType) => {
  const _bgColor = bgColor
    ? bgColor
    : isDisabled || type === "Disabled"
      ? colors.lightGray2
      : type === "Focused"
        ? colors.mainOrange
        : colors.mainPurple;

  return (
    <StyledButton
      $type={type}
      onClick={() => {
        onClick && onClick();
      }}
      disabled={isDisabled}
      $bgColor={_bgColor}
      $widthValue={width}
      $heightValue={height}
      $marginTop={$marginTop}
      $marginBottom={$marginBottom}
      $marginLeft={$marginLeft}
      $marginRight={$marginRight}
    >
      <StyledText.Headline16 color={colors.white}>{text}</StyledText.Headline16>
    </StyledButton>
  );
};
export default RoundRectangleButton;

interface OtherType {
  $type: ButtonType;
  disabled?: boolean;
  $widthValue?: string | number;
  $heightValue?: string | number;
  $bgColor?: string;
}

const StyledButton = styled.button<OtherType & MarginStyleType>`
  /* flex-direction: row; */
  border-radius: 26px;
  padding: 0px 16px; // 높이값이 44 아래일때 텍스트가 하단에 짤려서 위아래 padding값 삭제
  align-items: center;

  height: ${({ $heightValue }) =>
    typeof $heightValue === "number"
      ? `${$heightValue}px`
      : typeof $heightValue === "string"
        ? `${$heightValue}`
        : "44px"};
  background-color: ${({ $bgColor }) => $bgColor as string};
  ${({ $widthValue }) =>
    $widthValue
      ? css`
          width: ${typeof $widthValue === "number"
            ? `${$widthValue}px`
            : $widthValue};
        `
      : css`
          min-width: 96px;
        `};

  ${({ disabled, $type }) =>
    !disabled &&
    $type != "Disabled" &&
    css`
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);
    `};

  ${({ $marginTop }) =>
    $marginTop &&
    css`
      margin-top: ${$marginTop}px;
    `}
  ${({ $marginBottom }) =>
    $marginBottom &&
    css`
      margin-bottom: ${$marginBottom}px;
    `}
  ${({ $marginLeft }) =>
    $marginLeft &&
    css`
      margin-left: ${$marginLeft}px;
    `}
  ${({ $marginRight }) =>
    $marginRight &&
    css`
      margin-right: ${$marginRight}px;
    `}
`;
